module.exports = __webpack_public_path__ + "img/logo-full.4bd2a9b5.svg";